import {AfterViewInit, Component} from '@angular/core';
import {EditHomeAddressFragmentController} from './EditHomeAddressFragmentController';
import {MatDialog} from '@angular/material/dialog';
import {BaseViewUI} from '../../../../../BaseUI/BaseViewUI/BaseViewUI';
import {Router} from '@angular/router';
import {ExamAfterProcessInitialDataDTOInterface} from '../../../../../../DTO/ExamAfterProcessInitialDataDTOInterface';
import {PrescriptionDeliveryTargetConst} from '../../../../../../Enum/PrescriptionDeliveryTargetConst';
import {patternForName, patternForPostCode} from '../../../../../../Util/StringUtil';
import {UserDeliveryAddressDTOInterface} from '../../../../../../DTO/UserDeliveryAddressDTOInterface';
import {PrefectureConst} from '../../../../../../Enum/PrefectureConst';

@Component({
	selector: 'app-reserve-component',
	templateUrl: './EditHomeAddressFragmentComponent.html',
	styleUrls: ['../ExamAfterProcessLayout.scss', './EditHomeAddressFragmentComponent.scss'],
})

export class EditHomeAddressFragmentComponent extends BaseViewUI implements AfterViewInit {

	// 紐付いたコントローラー
	public combineCtrl: EditHomeAddressFragmentController;

	public updateHomeAddress: (data: UserDeliveryAddressDTOInterface) => void;
	public eventCancel: () => void;

	public prefectureList = PrefectureConst.getList();
	public bindData: UserDeliveryAddressDTOInterface = {
		id: 0,
		userId: 0,
		storeName: '',
		postCode: '',
		prefecture: '',
		city: '',
		address: '',
		building: '',
		toName: '',
		telNumber: '',
		faxNumber: '',
	};

	public errorHomeAddress = [];

	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog,
				public route: Router) {

		super();

		// コントローラーの生成
		this.createController(EditHomeAddressFragmentController);

	}

	/**
	 * ngAfterViewInit
	 *
	 * Angularのライフサイクル
	 * ビューの初期化後に一度だけ実行される
	 */
	public async ngAfterViewInit() {
	}


	/**
	 * 開始処理
	 */
	public async start() {

	}


	/**
	 * 郵便番号から住所を自動入力
	 */
	public async onClickAutoInputAddress(target: string) {
		this.log('Component::onClickAutoInputAddress()');
		const postCode = this.bindData.postCode;

		const ret = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.getAddress.bind(this),
			{ view: this, postCode }
		);
		if (!ret) {
			return;
		}
		this.bindData.prefecture = ret.prefecture;
		this.bindData.city = ret.city;

	}

	public async onClickUpdate(): Promise<void> {
		this.errorHomeAddress = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.validateHomeAddressData.bind(this),
			{ view: this, data: this.bindData }
		);

		console.log(this.errorHomeAddress);

		if (this.errorHomeAddress.length > 0) {
			const messageList = this.errorHomeAddress.map((item) => item.message);
			this.showAlertDialog('住所登録エラー', messageList.join('<br>'));
			return;
		}

		await this.updateHomeAddress(this.bindData);
	}

	public async onClickCancel(): Promise<void> {
		await this.eventCancel();
	}

	protected readonly patternForName = patternForName;
	protected readonly patternForPostCode = patternForPostCode;
}

